var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"search-bar-icon",attrs:{"height":"25","width":"25"}},[_c('circle',{staticClass:"glass",attrs:{"cx":"10","cy":"10","r":"7"}}),_c('path',{staticClass:"handle",attrs:{"d":"m16 16 l5 5 z"}}),_c('circle',{staticClass:"handle-end",attrs:{"cx":"22","cy":"22","r":"1"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }